export default __webpack_public_path__ + "static/bg-d449f9d0d8012080e53fd68f0ae6aaa3.webp";